export const CountryWages = {
  EU: 70,
  AUT: 70,
  BEL: 70,
  BIH: 30,
  CZE: 50,
  CRO: 30,
  DEN: 70,
  DEU: 70,
  EST: 40,
  FIN: 70,
  GRE: 60,
  IRL: 70,
  ISL: 80,
  ISR: 70,
  LAT: 40,
  LIT: 40,
  NED: 70,
  NOR: 80,
  POL: 40,
  POR: 60,
  ROM: 40,
  RUS: 50,
  USA: 95,
  SVK: 50,
  SLN: 50,
  SRB: 30,
  MNT: 30,
  ESP: 60,
  CHE: 80,
  SWE: 80,
  ITA: 70,
  TUR: 50,
  UKR: 50,
  UK: 70
};
